/**
 * Ticket: SL-698
 * JIRA: https://toolsvilla.atlassian.net/browse/SL-698
 * Description: Competitiveness Box show the market, competitor and 
 * overall competitiveness
 * Author - Ankit Nigam
 */
import React from "react";
import "./CompetitivenessBox.css";
import { Nav, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { NavLink } from "react-router-dom";
/**
 * Handle the UI to show the competitiveness
 * @returns 
 */
const CompetitivenessBox = ({ title, icon, percent, bgColor, bottomComment, style, comp, hoverText,to }) => {
  const imageSize = 42;
  const strokeWidth = 5
  const radius = (imageSize + strokeWidth) / 2;
  const size = radius * 2;
  const circumference = 2 * Math.PI * (radius - strokeWidth / 2);
  const correctedProgress = Math.min(percent, 99.9);
  const offset = circumference - (correctedProgress / 100) * circumference;


  // Clamp the percent value to stay between 0 and 100
  const clampedPercent = Math.min(100, Math.max(0, percent));

  // Calculate stops based on clamped percent
  const redStop = Math.min(clampedPercent, 33); // Red is up to 33%
  const orangeStop = Math.min(Math.max(clampedPercent - 33, 0), 33); // Orange is 33–66%
  const greenStop = Math.min(Math.max(clampedPercent - 66, 0), 34); // Green is 66–100%

  // Create gradient dynamically based on percentage
  const bgGradientColor2 = `linear-gradient(to right, 
   #FF0000 ${redStop}%, 
   #FFA500 ${redStop + orangeStop}%, 
   #00FF00 ${redStop + orangeStop + greenStop}%)`;

  const bgGradientColor = `linear-gradient(to right, red, orange, green)`;
  if (comp === 'home') {
    return (
      <div className="competitive-card" style={{ ...style }}>
        <NavLink exact to={to}>
        <Row className="my-2">
          <div className="col-9">
            <div className="competitive-header">
              <h3 className="competitive-title competitive-title-home">{title}</h3>
            </div>
            <div className="competitive-stats">
              <div className="competitive-percentage">
                <span className="competitive-percentage-value competitive-percentage-value-home">{percent}</span>

                {/* <span className={`competitve-diff-percent ${percent < 0 ? "text-success" : "text-red"}`}>-1%</span> */}
              </div>
            </div>
            {/* <div className="competitve-bottom-comment">{bottomComment}</div> */}
          </div>
          <div className="col-3 home-competitive-icon-i">
            {/* <div style={{ position: "relative", width: size, height: size }}> */}
              <i
                className={icon}>
              </i>
            {/* </div> */}
          </div>
        </Row>
        </NavLink>
      </div>
    )
  } else {
    return (
      <div className="competitive-card" style={{ "flex": "0 0 30%" }}>
        <div className="competitive-header">
          <h3 className="competitive-title">{title}</h3>
        </div>
        <div className="competitive-stats" style={{ marginBottom: '10px' }}>
          <div className="competitive-percentage">
            <span className="competitive-percentage-value">{percent}%</span>
            <div className="competitive-icon">
              <img src='/market-comp.png' />
            </div>
          </div>
        </div>
        {percent < 90 && <div className="comp-msg" style={{ fontSize: '11px', color: 'black', fontWeight: '400' }}>
          <img src="/warning-triangle.png" alt="warning" style={{ width: '14px', marginRight: '5px' }} />
          Losing order to competitors due to high prices
        </div>
        }
        <div className="competitive-progress-bar">
          <div className="competitive-progress" style={{ width: `${percent}%`, background: bgGradientColor2 }}></div>
        </div>
      </div>
    );
  }
};

export default CompetitivenessBox;
